import LessonHeaderContainer from './container';
import LessonHeader, { LessonHeaderProps } from './LessonHeader';

export type LessonHeaderProps = LessonHeaderProps;

export { LessonHeader };
export default LessonHeaderContainer;
